import { Position } from './types';

const POSITION_MAP: Record<string, Position> = {
  Goalkeeper: 'GK',
  Defender: 'DEF',
  Midfielder: 'MID',
  Forward: 'STR',
  GK: 'GK',
  DEF: 'DEF',
  MID: 'MID',
  STR: 'STR',
  FWD: 'STR',
};

export function normalizePosition(raw: string | null): Position {
  if (!raw) return 'MID';
  return POSITION_MAP[raw] ?? 'MID';
}
